import { RouterModule, Routes } from '@angular/router';
import { ViewCashMovementComponent } from './components/view-cash-movement/view-cash-movement.component';
import { ListCashMovementComponent } from './components/list-cash-movement/list-cash-movement.component';




export const CashMovementRouter: Routes = [
    { path: 'create', component: ViewCashMovementComponent},
    { path: 'view/:id', component: ViewCashMovementComponent},
    { path: 'list', component: ListCashMovementComponent }
];


// WEBPACK FOOTER //
// ./src/app/cashmovements/cash-movement.router.ts